<template>
  <vs-popup class="holamundo" :title="order.date +'  ' +order.time" :active.sync="isShown" v-esc="escape">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row id="orderHeader" vs-type="flex" vs-w="12">
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
          <span class="weight-600 text-secondary">
            {{order.branchName}}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
          <span class="weight-600 text-secondary">
            {{order.userName}}
          </span>
        </vs-col>
      </vs-row>
      <vs-row id="orderProducts" vs-type="flex" vs-w="12" class="mb-2 border-all border-radius border-secondary p-3">
        <vs-row vs-type="flex" vs-w="12" v-for="entry in order.cartEntries" :key="entry.id" class="border-bottom py-2">
          <vs-col :vs-w="entry.extras && entry.extras.length > 0 ? 8 : 12" class="px-1 text-center" style="align-self: center;">
            <span class="text-dark bold italic">
              - x{{ entry.quantity }} {{ entry.productName }}
            </span>
            <span class="text-primary bold ml-2">
              {{ $toCurrency(entry.price)}}
            </span>
          </vs-col>
          <vs-col vs-type="block" vs-w="4" class="px-1" v-if="entry.extras && entry.extras.length > 0">
            <vs-row vs-type="flex" vs-w="12" v-for="extra in entry.extras" :key="extra.id">
              <span class="w-full text-center text-smaller text-secondary bold">
                x{{ extra.quantity }} {{ extra.name }}
              </span>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
      <vs-row id="orderPayments" vs-type="flex" vs-w="12" class="border-all border-secondary border-radius p-3">
        <vs-col vs-type="block" vs-w="7" class="px-1">
          <vs-row vs-type="flex" vs-w="12" v-for="payment in order.paymentInformations" vs-justify="center" :key="payment.id" class="border-bottom py-2">
            <span class="text-dark weight-500">
              {{ payment.paymentMethod.name }} =
            </span>
            <span class="text-primary bold ml-2">
              {{ $toCurrency(payment.price) }}
            </span>
            <span class="text-secondary bold ml-2" v-if="payment.value > 0">
              ({{payment.value + payment.unit}})
            </span>
            <vs-row vs-type="flex" vs-w="12" v-if="payment.description" vs-justify="center">
              <span class="text-dark weight-600 italic">
                {{payment.description}}
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" v-if="payment.discountDescription" vs-justify="center">
              <span class="text-dark weight-600 italic">
                {{payment.discountDescription}}
              </span>
            </vs-row>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-w="5" class="px-1" vs-justify="center" vs-align="center">
          <span class="text-primary bold text-medium">
            {{ $toCurrency(order.totalPrice) }}
          </span>
        </vs-col>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
export default {
  name: "OrderReviewer",
  props: {
    order: {
      type: Object,
      required: true
    },
    openReviewer: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isShown: false
    }
  },
  methods: {
    escape() {
      if (this.isShown) this.isShown = false;
    }
  },
  watch: {
    openReviewer(val) {
      if (val) this.isShown = true;
    },
    isShown(val) {
      if (!val) this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>
